module.exports = __webpack_public_path__ + "img/phone-incoming.1b827c48.svg";